namespace GeniuzPOS.InventoryReport {
    export interface IcReport07SkuForm {
        RowRunNo: Serenity.IntegerEditor;
        SkuCode: Serenity.StringEditor;
        TranDate: Serenity.DateEditor;
        SysDocNo: Serenity.StringEditor;
        TranType: Serenity.StringEditor;
        QtyAdd: Serenity.DecimalEditor;
        QtyDel: Serenity.DecimalEditor;
        QtyBalance: Serenity.DecimalEditor;
        CostAdd: Serenity.DecimalEditor;
        CostDel: Serenity.DecimalEditor;
        CostBalance: Serenity.DecimalEditor;
    }

    export class IcReport07SkuForm extends Serenity.PrefixedContext {
        static formKey = 'InventoryReport.IcReport07Sku';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!IcReport07SkuForm.init)  {
                IcReport07SkuForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;
                var w2 = s.DateEditor;
                var w3 = s.DecimalEditor;

                Q.initFormType(IcReport07SkuForm, [
                    'RowRunNo', w0,
                    'SkuCode', w1,
                    'TranDate', w2,
                    'SysDocNo', w1,
                    'TranType', w1,
                    'QtyAdd', w3,
                    'QtyDel', w3,
                    'QtyBalance', w3,
                    'CostAdd', w3,
                    'CostDel', w3,
                    'CostBalance', w3
                ]);
            }
        }
    }
}
